var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"loading",class:{ 'visually-hidden': !_vm.loading }},[_vm._t("loading",function(){return [_c('i',{staticClass:"fad fa-spinner-third fa-spin"})]})],2),_c('div',{staticClass:"loaded",class:{ 'visually-hidden': _vm.loading }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }